import React, { Component } from "react";

import Links from "./scenario-links";

import ScenariosIntro from "./scenarios-intro";
import Catalog from "./scenario-catalog";

import Helmet from "react-helmet";
import Spinner from "./spinner"

import image from "../imgs/image.jpg";


import { initializeMsalProvider } from "./authProvider";
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import jwt_decode from "jwt-decode";




let Vimeo = require('vimeo').Vimeo;
var videos ={}
var vidnum=0;


let seo = {
  BR1: {
    title: "Systems Integrator Scenario | Project Ares Cyber Curriculum Guide ",
    description:
      "Project Ares Foundational scenario, Battle Room 1, Systems Integrator, builds analysis and configuration skills.  ",
    canonical: "https://projectares.academy/learning-catalog/br1-system-integrator"
  },

  BR2: {
    title: "Network Analysis Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 2, Network Analysis, build skills in cyber defense analysis, patch and release management, signature development. ",
      canonical: "https://projectares.academy/learning-catalog/br2-network-analysis"
  },
  BR5: {
    title: "Intel Analyst Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 5, Intel Analyst, build skills in threat detection. ",
      canonical: "https://projectares.academy/learning-catalog/br5e-intel-analyst"
  },
  BR6: {
    title: "Linux Basics Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 6, Linux Basics, build skills for Linux-based network operations.",
      canonical: "https://projectares.academy/learning-catalog/br6e-linux-basics"
  },
  BR8: {
    title: "Traffic Analysis Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 8, Traffic Analysis, build skills in network forensics, traffic analysis, credientialing, document exfiltration and database activity.  ",
      canonical: "https://projectares.academy/learning-catalog/br8-network-traffic-analysis"
  },
  BR9: {
    title: "Forensics Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 9, Forensics, build skills in digital forensics to conduct data recovery and support a case of an intrusion.  ",
      canonical: "https://projectares.academy/learning-catalog/br9e-forensics"
  },
  BR10: {
    title:
      "Scripting Fundamentals Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 10, Scripting Fundamentals, build skills in string manipulation, file manipulation, conditional statements, and exception handling. ",
      canonical: "https://projectares.academy/learning-catalog/br10-scripting-fundamentals"
  },
  BR11: {
    title:
      "System Security Analysis Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 11, System Security Analysis, build skills in reconnaissance, domain administration, and log collection and analysis. ",
      canonical: "https://projectares.academy/learning-catalog/br11-system-security-analyst"
  },
  BR13: {
    title: "SII London Red Team Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 13, SII London Red Team, build skills in penetration testing. ",
      canonical: "https://projectares.academy/learning-catalog/br13-capture-the-flag-1"
  },
  BR14: {
    title:
      "SII San Diego Red Team Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 14, SII San Diego Red Team, build skills in penetration testing. ",
      canonical: "https://projectares.academy/learning-catalog/br14-capture-the-flag-2"
  },
  BR15: {
    title:
      "Internal Web Penetration Test Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 15, Internal Web Penetration Test, build skills in penetration testing. ",
      canonical: "https://projectares.academy/learning-catalog/br15-capture-the-flag-3"
  },
  BR16: {
    title:
      "Internal Penetration Test Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 16, Internal Penetration Test, build skills in penetration testing. ",
      canonical: "https://projectares.academy/learning-catalog/br16-capture-the-flag-4"
  },
  BR17: {
    title:
      "Network Packet Trace Analysis Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 17, Network Packet Trace Analysis, build skills in packet capture and analysis. ",
      canonical: "https://projectares.academy/learning-catalog/br17-capture-the-flag-5"
  },
  BR21: {
    title:
      "Powershell Fundamentals Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Foundational scenario, Battle Room 21, Powershell Fundamentals, build skills in using Powershell cmdlets for file system navigation. ",
      canonical: "https://projectares.academy/learning-catalog/br21-powershell"
  },
  BR22: { title: "", description: "" },
  BR29: { title: "", description: "" },
  M1E: {
    title: "Disable Botnet Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 1, Easy level, Disable Botnet, build skills in Computer Languages, Information Systems and Network Security, and Infrastructure Design and more. ",
      canonical: "https://projectares.academy/learning-catalog/m1e-disable-botnet"
  },
  M1M: {
    title: "Disable Botnet Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 1, Medium level, Disable Botnet, build skills in Computer Languages, Information Systems and Network Security, and Infrastructure Design and more. ",
      canonical: "https://projectares.academy/learning-catalog/m1m-disable-botnet"
  },
  M2E: {
    title:
      "Stop Terrorist Financing Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 2, Easy level, Stop Terrorist Financing, build skills in Computer Languages, Infrastructure Design and Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m2e-file-theft"
  },
  M2M: {
    title:
      "Stop Terrorist Financing Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 2, Easy level, Stop Terrorist Financing, build skills in Computer Languages, Infrastructure Design, Hacking Methodologies and Vulnerability Assessment. ",
      canonical: "https://projectares.academy/learning-catalog/m2m-file-theft"
  },
  M3E: {
    title:
      "Intercept Attack Plans Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 3, Easy level, Intercept Attack Plans, build skills in Computer Languages, Infrastructure Design, and Vulnerability Assessment.",
      canonical: "https://projectares.academy/learning-catalog/m3e-buffer-overflow"
  },
  M3M: {
    title:
      "Intercept Attack Plans Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 3, Medium level, Intercept Attack Plans, build skills in Computer Languages, Infrastructure Design, and Vulnerability Assessment.",
      canonical: "https://projectares.academy/learning-catalog/m3m-buffer-overflow"
  },
  M4E: {
    title:
      "Stop Malicious Processes Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 4, Easy level, Stop Malicious Processes, build skills in Computer Languages, Network Defense, Incident Response Management, Information Systesms and Network Security, Infrastructure Design, Operating Systems.",
      canonical: "https://projectares.academy/learning-catalog/m4e-exfil"
  },
  M4M: {
    title:
      "Stop Malicious Processes Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 4, Easy level, Stop Malicious Processes, build skills in Computer Network Defense, Enterprise Architecture, Incident Response Management, Information Systems and Network Security, Infrastructure Design, Operating Systems. ",
      canonical: "https://projectares.academy/learning-catalog/m4m-stop-malicious-process-operation-arctic-cobra"
  },
  M5E: {
    title:
      "Protect Financial Institution Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 5, Easy level, Protect Financial Institution, build skills in Computer Languages, Computer Network Defense, Incident Response Management, Information Systems and Network Security, and Operation Systems. ",
      canonical: "https://projectares.academy/learning-catalog/m5e-malware"
  },
  M5M: {
    title:
      "Protect Financial Institution Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 5, Medium level, Protect Financial Institution, build skills in Computer Network Defense, Incident Response Management, Information Systems and Network Security, and Operation Systems. ",
      canonical: "https://projectares.academy/learning-catalog/m5m-malware"
  },
  M6E: {
    title:
      "Respond to Phishing and Exfiltration Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 6, Easy level, Respond to Phishing and Exfiltration, build skills in Computer Network Defense, Enterprise Architecture, Information Systems and Network Security, Infrastructure Design, Operating Systems, Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m6e-phishing"
  },
  M6M: {
    title:
      "Respond to Phishing and Exfiltration Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 6, Medium level, Respond to Phishing and Exfiltration, build skills in Computer Network Defense, Enterprise Architecture, Information Systems and Network Security, Infrastructure Design, Operating Systems, Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m6m-phishing"
  },
  M8E: {
    title:
      "Defend ICS/SCADA System Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 8, Easy level, Defend ICS/SCADA System, build skills in Computer Languages, Computer Network Defense, Information Systems and Network Security, Infrastructure Design, Network Management, Operating Systems. ",
      canonical: "https://projectares.academy/learning-catalog/m8e-operation-ocean-view"
  },
  M9E: {
    title:
      "Manipulate Industrial Control System Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 9, Easy level, Manipulate Industrial Control System, build skills in Infrastructure Design, Operating Systems, Vulnerability Assessment, Hacking Methodologies, ",
      canonical: "https://projectares.academy/learning-catalog/m9e-waterfall-flash"
  },
  M10E: {
    title: "Ransomware Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 10, Easy level, Ransomware, build skills in Computer Network Defense, Enterprise Architecture, Information Systems and Network Security, Infrastructure Design, Operating Systems, Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m10e-operation-crimson-wolf"
  },
  M12E: {
    title:
      "Defend Against Web Attacks Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 12, Easy level, Defend Against Web Attacks, build skills in Computer Languages, Computer Network Defense, Incident Response Management, Information Systems and Network Security, Infrastructure Design, Network Management, Operating Systems, Vulnerability Assessment, Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m12e-operation-bold-hermit"
  },
  M12M: {
    title:
      "Defend Against Web Attacks Scenario| Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 12, Medium level, Defend Against Web Attacks, build skills in Computer Languages, Computer Network Defense, Incident Response Management, Information Systems and Network Security, Infrastructure Design, Network Management, Operating Systems, Vulnerability Assessment, Hacking Methodologies. ",
      canonical: "https://projectares.academy/learning-catalog/m12m-operation-bold-hermit"
  },
  M13E: {
    title:
      "Power Grid Incident Response Scenario | Project Ares Cyber Curriculum Guide",
    description:
      "Project Ares Specialized scenario, Mission 13, Easy level, Power Grid Incident Response, build skills in Digital Forensics, Computer Languages, Computer Network Defense, Incident Response Management, Information Assurance, Information Systems and Network Security, Infrastructure Design, Operating Systems.",
      canonical: "https://projectares.academy/learning-catalog/m13e-operation-black-dragon"
  },
};

const yaml = require("js-yaml");
const fs = require("fs");

let base64 = require("base-64");

var username = "svc-parc-vsts@circadence.com"; // app clientID
var password = "ucrrc6lqncp7tmx3aojeqmh72hsa542oil2jplgw4py6nlwi7u3a"; // app clientSecret

 
function isNumber(n) {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}



const promisifiedVimeoClient = (url) => {
  return new Promise((resolve, reject) => {
    client.request(url, (error, result) => error ? reject(error) : resolve(result) );
  });
}



async function vimeoRequest(e,page) {
  try {
    const data = await promisifiedVimeoClient({
      method: 'GET',
    
      path: e+"/videos?per_page=100&page="+page,
    });
    return data;
     
  } catch ( error ) {
    console.error('error', error);
  }
}


async function vimeoRequestLooped(e,page) {
 var localpage=page
  for(;videos.length<vidnum;localpage=localpage+1){
  try {
    const data = await promisifiedVimeoClient({
      method: 'GET',
    
      path: e+"/videos?per_page=100&page="+localpage,
    });

   // console.log(data.data,videos.length,vidnum)
    videos = videos.concat(data.data)
  } catch ( error ) {
    console.error('error', error);
  }

}
if(videos.length==vidnum){
  console.log("success")
  
}
return null
}

 

function addStr(str, index, stringToAdd){
  return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
}








class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
 
scenarios:{},
gs:{},
kb:{},
faqs:{},
videos:{}

    };
   
  }

 

  render() {
    return (

        <AzureAD provider={this.props.provider} >
    {
    ({authenticationState, error, accountInfo}) => {
      switch (authenticationState) {
        case AuthenticationState.Authenticated:
          return (
            <><div className="user">
             <strong> <span>Welcome, {accountInfo.account.name},</span>
             
          <span>{jwt_decode(accountInfo.jwtIdToken).extension_IsAresTrainer?" Trainer":" Player"}</span></strong>
            
          
             </div>
             { jwt_decode(accountInfo.jwtIdToken).extension_IsAresTrainer?this.props.authenticated:
            <p><strong>Oops! It looks like you've tried to access the Curriculum Guide as a Player. 
               <br/>Access to scenario hints, answers, and scoring is for Trainers only.</strong>
               <br/><br/>If you have a requirement to switch to Trainer role, please contact our Customer Support team at <a href='mailto:CSD@circadence.com'>CSD@circadence.com.</a></p>}
            </>
          );
        case AuthenticationState.Unauthenticated:
          return (
            <div className="loginInstructions">
              <div>
              {this.props.unauthenticated}
              {error && <p><span>An error occured during authentication, please try again!</span></p>}
             {error && console.log(error)}
               
             
             </div>

             <div className='arrow-wrapper'>
               
             
<svg version="1.1"  x="0px" y="0px"  viewBox="0 0 296 153.1"  >
 
<path class="st0" d="M295.3,5.2c-0.2-1.4-0.4-2.8-0.5-4.3c0-0.3-0.2-0.6-0.6-0.8c-0.3-0.2-0.7-0.1-1,0.1c-3.8,2.4-7.1,5.7-12.2,10.8
	l-2.4,2.4c-0.3,0.3-0.4,0.8-0.2,1.2c0.2,0.4,0.7,0.6,1.1,0.5l7.4-1.6c-44,118.3-145.4,162.4-285.7,124.2c-0.5-0.1-1.1,0.2-1.2,0.7
	c-0.1,0.5,0.2,1.1,0.7,1.2c33.4,9.1,64.5,13.6,93.2,13.6c36.3,0,68.9-7.3,97.2-21.8c44.5-22.8,77.5-62.5,98-118l4.4,6.7
	c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.1,0,0.2,0c0.4-0.1,0.7-0.4,0.8-0.8C296.5,14.4,295.9,10.1,295.3,5.2z M293.8,16.9l-3.6-5.6
	c-0.2-0.3-0.5-0.5-0.8-0.5c-0.1,0-0.1,0-0.2,0l-6.6,1.5c4.3-4.4,7.4-7.4,10.5-9.6c0.1,0.9,0.2,1.9,0.4,2.7
	C293.8,9.4,294.3,12.9,293.8,16.9z"/>
</svg>


             </div>
            </div>
          );
        case AuthenticationState.InProgress:
          return (<p>Authenticating...</p>);
        default:
          return <></>
      }
    }
  }
      </AzureAD>
    )
  }

}




class Tyr extends Component {
  constructor() {
    super();
    this.myRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
   
    if (this.myRef.current && this.props.tyr) {
     // console.log(this.props.tyr)
      this.myRef.current.innerHTML = this.props.tyr[1]?this.props.tyr[1].text:this.props.tyr.text?this.props.tyr.text:"tyr text not found";
    }
  }

  componentDidUpdate() {
    if (this.myRef.current && this.props.tyr) {
      this.myRef.current.innerHTML = this.props.tyr[1]?this.props.tyr[1].text:this.props.tyr.text?this.props.tyr.text:"tyr text not found";
    }
  }

  render() {
    return (
      <>
        <h4>Question</h4>
        <p ref={this.myRef}></p>
      </>
    );
  }
}

let client = new Vimeo("089bf6c85b628e35642fb1fcc1f29fea71461a52", "FN2n0mZMDxBeCNpmAFTx7Jvbtf3uPJL5MQRufc+Tun0bpAaV7nFoeHzVcKTh6+Qq+9a2dhO+g7WWaAzl7M0iq6jifOeaR8ONAAiam1mOPeZm7dUaMAcj6JywhiR6MXSz", "9453c9e86ddeea467f8bfb54e378a427");
 
 

class Data extends Component {
  constructor() {
    super();
    const msalProvider = initializeMsalProvider();
    this.state = {
      whitelisted: false,
      msalProvider    
    };
  }


  getVimeoFolder=()=>{
var page=1;




   
    var tempLoc;


    if(this.state.location[0]=="B")
    { 
      
       //pre 0 is added to single digit battlerooms for vimeo folder name comparison
      tempLoc=this.state.location.length===3?addStr(this.state.location,2,"0"):this.state.location;}
    else{
      tempLoc=this.state.location;
    }

   
//console.log("vimeo props",tempLoc,this.props.projects, this.props.projects[this.props.projects.findIndex((e)=>{return e.name===tempLoc? true:false})])


 

  if(this.props.projects[this.props.projects.findIndex((e)=>{return e.name===tempLoc? true:false})]){

    vimeoRequest(this.props.projects[this.props.projects.findIndex((e)=>{return e.name===tempLoc? true:false})].uri,page).then((response) => {
    //  console.log('found');
       videos=response.data;
       vidnum=response.total;
    
      
    if(videos.length<vidnum){
  //  console.log('for loop')
         vimeoRequestLooped(this.props.projects[this.props.projects.findIndex((e)=>{return e.name===tempLoc? true:false})].uri,2).then((response) => {
         
    
           videos=videos.sort((a, b) => (a.name > b.name) ? 1 : -1);
          
         })
    
       }
     
    this.setState({
     videos:videos.sort((a, b) => (a.name.substring(a.name.indexOf("_"),a.name.length) > b.name.substring(b.name.indexOf("_"),b.name.length)) ? 1 : -1)
    })
    
    
    
    
    
     })
     
  }
 

 

  
}


 




  getData=(e)=> {
    var dif = "e";
    var xhr4 = new XMLHttpRequest();
  

    // get a callback when the server responds
    xhr4.addEventListener("load", () => {
      try {
        this.setState({
          data: yaml.load(xhr4.responseText, "utf8"),
          dif: dif,
        }, this.getVimeoFolder());
      } catch (error) {
        console.error(error);
        this.setState({
          error: error,
          dif: "e",
        });
      }
    });

    if (e.charAt(e.indexOf("_") - 1) === "M") {
      // console.log("m")

      dif = "m";
      xhr4.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/vem/medium/services_0.yaml&api-version=6.0"
      );

      xhr4.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );
      // send the request
      xhr4.send();
      return;
    }

    if (e.charAt(e.indexOf("_") - 1) === "H") {
      // console.log("h")

      dif = "h";
      xhr4.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/vem/hard/services_0.yaml&api-version=6.0"
      );

      xhr4.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );
      // send the request
      xhr4.send();
      return;
    }
    if (
      e.charAt(e.indexOf("_") - 1) !== "M" &&
      e.charAt(e.indexOf("_") - 1) !== "H"
    ) {
      dif = "e";
      //  console.log("number")
      // open the request with the verb and the url
      xhr4.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/vem/easy/services_0.yaml&api-version=6.0"
      );

      xhr4.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );
      // send the request
      xhr4.send();
      return;
    }
  }

  componentDidMount() {

    this.clearData();

    const location = window.location.pathname.split("/");

    this.setState(
      {
        location: location[2] ? location[2].toUpperCase() : undefined,
      },
      () => this.handleData()
    );
   

    //console.log("get", this.state, this.props);
  }

  handleData = () => {
    //FIX FOR M9,M10, M13, M14. PATHSMIN have no difficulty in path e.g. M9E

    if (
      this.state.location == "M10E" ||
      this.state.location == "M13E" ||
      this.state.location == "M14E"
    ) {
      this.getData(
        this.props.allpaths[
          this.props.pathsmin.indexOf(
            this.state.location.substring(0, this.state.location.length - 1)
          )
        ]
      );
    } else if (this.state.location) {
      this.getData(
        this.props.allpaths[this.props.pathsmin.indexOf(this.state.location)]
      );
    }
  };

  clearData = () => {
    this.setState({
      data: undefined,
      dif: undefined,
      location: undefined,
      videos:undefined
    });
  };




variableHints=(key)=>{

//var cleanKey=key.text.replace(/[()]/g, '').replace("[0]","_");
var cleanKey=key.text.substring(key.text.indexOf("(((")+3,key.text.indexOf(")))")).replace("[0]","_");
var answers=[];
var list;


if(this.state.location=="BR2"){

  for(var i = 1;this.state.data.variables.assign[cleanKey+i]!==undefined;i++){
    answers.push(this.state.data.variables.assign[cleanKey+i])
    //console.log(answers)
  }
}


if(this.state.location=="BR1"){
  //console.log("BR1",cleanKey.substring(cleanKey.indexOf('_'),cleanKey.length-1))

  var variables =  Object.keys(this.state.data.variables.assign)


  for(var i = 1;i<variables.length;i++){
     

if(variables[i].includes(cleanKey.substring(cleanKey.indexOf('_'),cleanKey.length-1))){
  
  answers.push(this.state.data.variables.assign[variables[i]][0])
  //console.log(answers)
}

    
  }

 
}

list=<>{ key.text.replace("((("+cleanKey.substring(0,cleanKey.length-1)+"[0])))","")}<ul style={{padding:"1em 0 0 0"}}>{answers.map((answer, index) => {  return (  <li>{answer}</li>  );})} </ul></>
 


 return answers.length!==0 ? list:null


}


  hints = (hints) => {
    return (
      <>
        <h4>Hints</h4>

        <ol>
          {hints.map((key, index) => {
            return (
              <li key={index}>
                {" "}
                <span className="index">{index + 1}</span>
                <span>
                  <span className="points">-{key.points} Points </span>
                 




            {index,key.text.includes('(((')?this.variableHints(key):
   

<span dangerouslySetInnerHTML={{__html:key.text.replace(/</gi,'&lt;').replace(/>/gi,"&gt;").replace(/&lt;#00CCFF&gt;/gi, "<span style='color:#276a8e'>").replace(/&lt;#008000&gt;/gi, "<span style='color:#008000'>").replace(/&lt;.color&gt;/gi, "</span>")}} >
       {/*M1E colors*/}
 
</span>}

                
              
                </span>
              </li>
            );
          })}
        </ol>
      </>
    );
  };

  handleLocationChange = (e) => {
    this.clearData();

    this.setState(
      {
        location: e,
      },
      () => this.handleData()
    );
  };

  hints8 = (hints) => {
    return (
      <>
        <h4>Hints</h4>

        <ol>
          {hints.map((key, index) => {
            return (
              <li key={index}>
                {" "}
                <span className="index" style={{ marginRight: ".5em" }}>
                  {index + 1}{" "}
                </span>
                <span>{this.state.data.variables.assign[key][0]}</span>
              </li>
            );
          })}
        </ol>
      </>
    );
  };

  addPoints(e) {
    if (e?.length < 0) return 0
    return e?.reduce((acc, current) => acc + parseInt(current?.points), 0)
  }

  render() {
    return (
      <>
        {this.state.location ? (
          <Helmet>
            {seo[this.state.location] ? (
              <meta
                name="description"
                content={seo[this.state.location].description}
              />
            ) : (
              <meta
                name="description"
                content="The one-stop-shop for queries about Project Ares. Getting Started, Scenario Guides, Customer Support, Product Updates, and more."
              />
            )}

            <meta property="og:locale" content="en_US" />

            {seo[this.state.location] ? (
              <meta
                property="og:title"
                content={seo[this.state.location].title}
              />
            ) : (
              <meta
                property="og:title"
                content="Project Ares Resource Center"
              />
            )}

            {seo[this.state.location] ? (
              <meta
                property="og:description"
                content={seo[this.state.location].description}
              />
            ) : (
              <meta
                property="og:description"
                content="The one-stop-shop for queries about Project Ares. Getting Started, Scenario Guides, Customer Support, Product Updates, and more."
              />
            )}

            {seo[this.state.location] ? (
              <meta
                property="og:site_name"
                content={seo[this.state.location].title}
              />
            ) : (
              <meta
                property="og:site_name"
                content="Project Ares Resource Center"
              />
            )}

            <meta property="og:image" content={image} />
            <meta property="og:image:secure_url" content={image} />
            <meta property="og:image:width" content="1280" />
            <meta property="og:image:height" content="720" />
            {seo[this.state.location] ? (
              <link rel="canonical" href={seo[this.state.location]?.canonical} />
            ) : (
              <link rel="canonical" href="https://projectares.academy/learning-catalog" />
            )}
          </Helmet>
        ) : (
          <>
            <Helmet>
              <meta
                name="description"
                content="Project Ares Cyber Curriculum Scenario Guides to view Foundational, Specialized, and Assessment activity details including summaries, prerequsite knowledge, and more. "
              />

              <meta property="og:locale" content="en_US" />

              <meta
                property="og:title"
                content="Cyber Curriculum Guide | Project Ares Resource Center "
              />
              <meta
                property="og:description"
                content="Project Ares Cyber Curriculum Scenario Guides to view Foundational, Specialized, and Assessment activity details including summaries, prerequsite knowledge, and more."
              />

              <meta
                property="og:site_name"
                content="Cyber Curriculum Guide | Project Ares Resource Center "
              />
              <meta property="og:image" content={image} />
              <meta property="og:image:secure_url" content={image} />
              <meta property="og:image:width" content="1280" />
              <meta property="og:image:height" content="720" />
              <link rel="canonical" href="https://projectares.academy/learning-catalog" />
            </Helmet>
            <ScenariosIntro />{" "}
            <Links
              email={this.props.email}
              scenarios={this.props.scenarios}
              grid={true}
              master={this.props.master}
              links={this.props.pathsmin}
            />
          </>
        )}


           {this.state.data || this.state.error ? (
          <>
            {}
            {
              <Catalog
              write={this.props.write}
                dif={this.state.dif}
                links={
                  <Links
                    clearData={this.clearData}
                    handleLocationChange={this.handleLocationChange}
                    scenarios={this.props.scenarios}
                    titles={this.props.titles}
                    location={this.state.location}
                    grid={false}
                    master={this.props.master}
                    links={this.props.pathsmin}
                  />
                }
                scenarios={this.props.scenarios}
                active={
                  isNumber(this.state.location[this.state.location.length - 1])
                    ? this.state.location
                    : this.state.location.substring(
                        0,
                        this.state.location.length - 1
                      )
                }
                loggedIn={this.props.loggedIn}
                email={this.props.email}
                hints={
                  this.state.location && !this.props.loggedIn ? (
                    <>
              <Auth provider={this.state.msalProvider} authenticated={

(
                      this.state.location === "BR8" ? (
                        <>
                          <h3>Questions</h3>{" "}
                          <span style={{ margin: "0 0 1em 0" }}>
                            Questions may not appear in order{" "}
                          </span>
                          <ul className="objectives">
                            {Object.keys(this.state.data.variables.assign)
  
                              .filter((key) => key.includes("d"))
                              .map((key, index) => {
                                return (
                                  <li key={key}>
                                    <span
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        event.target.parentNode.parentNode.classList.toggle(
                                          "expanded"
                                        );
                                      }}
                                    >
                                      <h4>
                                        {index + 1}{" "}
                                        {this.state.data.variables.assign[
                                          key
                                        ][0].substring(0, 40) + "..."}
                                      </h4>
                                    </span>
  
                                    <div className="content">

                                    {this.state.videos&&this.state.videos[index]?  (
                                    <div className="vimeo-wrapper">  <iframe onLoad={(e)=>{e.target.classList.add('loaded')}}
                                        src={
                                          "https://player.vimeo.com/video/" +
                                          this.state.videos[index].link.split("/")[3] +
                                          "?title=0&byline=0&portrait=0"
                                        }
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen"
                                        allowFullScreen=""
                                      ></iframe><span className="spin"></span></div>
                                      ):""}
                                      <p>
                                        {" "}
                                        {this.state.data.variables.assign[key][0]}
                                      </p>
  
                                      {this.hints8(
                                        Object.keys(
                                          this.state.data.variables.assign
                                        ).filter(
                                          (keyb) =>
                                            keyb.includes("h") &&
                                            keyb.substring(
                                              0,
                                              keyb.indexOf("_")
                                            ) ==
                                              key.substring(0, key.indexOf("_"))
                                        )
                                      )}
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </>
                      )
                      
                      :this.state.location === "BR15" ? (
                        <>
                  



                          <h3>Objectives</h3>
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {isNumber(key.tag[0]) ? (
                                        key.tag
                                      ) : (
                                        <>
                                          {index + 1} {key.tag}
                                        </>
                                      )}
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">
 
                        
                                  {this.state.videos&&this.state.videos.filter(video => video.name.includes('Obj'))[index]? (
                          <div className="vimeo-wrapper">  <iframe
                          src={
                            "https://player.vimeo.com/video/" +
                            this.state.videos.filter(video => video.name.includes('Obj'))[index].link.split("/")[3] +
                            "?title=0&byline=0&portrait=0"
                          }
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay; fullscreen"
                          allowFullScreen=""
                        ></iframe><span className="spin"></span></div>
                        ):""}
                      
  
                                    <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
 
                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>

                          <h3  style={{marginTop:"2em"}}>Flags</h3>
                <ul className="objectives">  {this.state.videos? (
                                     this.state.videos.map( (key,index)=>{
                                      return   <>
                                      
                                     {key.name.includes('Flag')? <li key={index}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                            {index+1}
                                    </h4>
                                  
                                  </span>
  
                                  <div className="content">
                                      
                                       <div className="vimeo-wrapper">  <iframe
                                      src={
                                        "https://player.vimeo.com/video/" +
                                        key.link.split("/")[3] +
                                        "?byline=0&portrait=0"
                                      }
                                      width="100%"
                                      height="100%"
                                      frameBorder="0"
                                      allow="autoplay; fullscreen"
                                      allowFullScreen=""
                                    ></iframe><span className="spin"></span></div><br/>
                                    
                                    
                                    </div></li>:''}
                                    
                                    
                                    
                                    </>
                                   
                                    })
         
                                      ):""}</ul>



                        </>
                      )                 : this.state.location === "BR22" ? (
                        <>
                          <h3>Objectives</h3>{" "}
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {
                                        this.state.data.configurations.tyr.salt
                                          .questions[0][index].title
                                      }
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">
                                  {this.state.videos&&this.state.videos[index]?  (
                                    <div className="vimeo-wrapper">  <iframe onLoad={(e)=>{e.target.classList.add('loaded')}}
                                        src={
                                          "https://player.vimeo.com/video/" +
                                          this.state.videos[index].link.split("/")[3] +
                                          "?title=0&byline=0&portrait=0"
                                        }
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen"
                                        allowFullScreen=""
                                      ></iframe><span className="spin"></span></div>
                                      ):""}
                                    {/*this.props.videos.hasOwnProperty(
                                      isNumber(key.tag[0])
                                        ? isNumber(key.tag[1])
                                          ? key.tag.substring(2, key.tag.length)
                                          : key.tag.substring(1, key.tag.length)
                                        : key.tag.replace(/^\s+|\s+$/g, "")
                                    ) ? (
                                      <iframe
                                        src={
                                          "https://player.vimeo.com/video/" +
                                          this.props.videos[
                                            isNumber(key.tag[0])
                                              ? isNumber(key.tag[1])
                                                ? key.tag.substring(
                                                    2,
                                                    key.tag.length
                                                  )
                                                : key.tag.substring(
                                                    1,
                                                    key.tag.length
                                                  )
                                              : key.tag.replace(/^\s+|\s+$/g, "")
                                          ].split("/")[3] +
                                          "?title=0&byline=0&portrait=0"
                                        }
                                        width="720"
                                        height="405"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen"
                                        allowFullScreen=""
                                      ></iframe>
                                    ) : (
                                      ""
                                    )*/}
  
                                    <p> {key.description}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
  
                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      ) : this.state.location === "BR29" ? (
                        <>
                          <h3>Technical Overview</h3>
                          <div className="vimeo-wrapper" style={{marginBottom:"2em"}}>  
                          <iframe
                              src={
                              
                                "https://player.vimeo.com/video/522493275?title=0&byline=0&portrait=0"
                              }
                              width="100%"
                              height="100%"
                              frameBorder="0"
                              allow="autoplay; fullscreen"
                              allowFullScreen=""
                            ></iframe><span className="spin"></span></div>

                          <h3>Objectives</h3>{" "}
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                    {index + 1}  {
                                        this.state.data.configurations.tyr.salt
                                          .questions[index][0].group_title
                                      }
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">
 
                                  {this.state.videos&&this.state.videos[index]? (
                                     <div className="vimeo-wrapper">  <iframe
                                     src={
                                       "https://player.vimeo.com/video/" +
                                       this.state.videos[index].link.split("/")[3] +
                                       "?title=0&byline=0&portrait=0"
                                     }
                                     width="100%"
                                     height="100%"
                                     frameBorder="0"
                                     allow="autoplay; fullscreen"
                                     allowFullScreen=""
                                   ></iframe><span className="spin"></span></div>
                                      ):""}
                         
  
                                  
                                  
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
  
                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      ) : this.state.location === "M1E" ? (
                        <>
                                     <h3>Objectives</h3>{/*ALL SCENARIOS */}
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {isNumber(key.tag[0]) ? (
                                        key.tag
                                      ) : (
                                        <>
                                          {index + 1} {key.tag}
                                        </>
                                      )}
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">

                                  {this.state.videos&&this.state.videos[index]? (
                                     this.state.videos.map( (key)=>{
                                      return   key.name.includes("Obj0"+(index+1))?  <> <div className="vimeo-wrapper">  <iframe
                                      src={
                                        "https://player.vimeo.com/video/" +
                                        key.link.split("/")[3] +
                                        "?byline=0&portrait=0"
                                      }
                                      width="100%"
                                      height="100%"
                                      frameBorder="0"
                                      allow="autoplay; fullscreen"
                                      allowFullScreen=""
                                    ></iframe><span className="spin"></span></div><br/></>:""
                                   
                                    })
         
                                      ):""}

                      
  
                                    <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
 
                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      )  : this.state.location === "M2E" ? (
                        <>
                          <h3>Objectives</h3>
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {isNumber(key.tag[0]) ? (
                                        key.tag
                                      ) : (
                                        <>
                                          {index + 1} {key.tag}
                                        </>
                                      )}
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">
                                  {this.state.videos&&this.state.videos[index]? (
                                    <>{this.state.videos.map( (key,i) => {
                                      let portNumber;
                                      const indexVideo = index+1
                                      if ( key.name.includes("Obj0"+(indexVideo)) ) {
                                        if (indexVideo === 2 && i === 1) {
                                          portNumber = 2121
                                        } else if(indexVideo === 2 && i === 2) {
                                          portNumber = 3632
                                        } else if(indexVideo === 2 && i === 3) {
                                          portNumber = 80
                                        }

                                        return   (
                                          <>
                                            {portNumber && <h5>Port {portNumber}</h5>}
                                            <div className="vimeo-wrapper">
                                              <iframe
                                                src={`https://player.vimeo.com/video/${key.link.split("/")[3]}?byline=0&portrait=0`}
                                                width="100%"
                                                height="100%"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen"
                                                allowFullScreen=""
                                              ></iframe>
                                              <span className="spin"></span>
                                            </div><br />
                                          </>
                                        )
                                      }
                                    })}</>
         
                                  ):(
                                    <>
                                      {this.state.videos&&this.state.videos[index]? (
                                        <div className="vimeo-wrapper">
                                          <iframe
                                        src={
                                          "https://player.vimeo.com/video/" +
                                          this.state.videos[index].link.split("/")[3] +
                                          "?title=0&byline=0&portrait=0"
                                        }
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen"
                                        allowFullScreen=""
                                      ></iframe><span className="spin"></span></div>
                                      ):""}
                                    </>
                                  )}

                      
  
                                    <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
 
                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      )  : this.state.location === "BR13" ? (
                        <>
                          <h3>Objectives</h3>
                          <ul className="objectives">
                            {this.state.data.objectives.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {isNumber(key.tag[0]) ? (
                                        key.tag
                                      ) : (
                                        <>
                                          {index + 1} {key.tag}
                                        </>
                                      )}
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">
                                  {this.state.videos&&this.state.videos[index]? (
                          <div className="vimeo-wrapper">  <iframe
                          src={
                            "https://player.vimeo.com/video/" +
                            this.state.videos[index].link.split("/")[3] +
                            "?title=0&byline=0&portrait=0"
                          }
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay; fullscreen"
                          allowFullScreen=""
                        ></iframe><span className="spin"></span></div>
                                      ):""}

                      
  
                                    <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}

                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                          <h3  style={{marginTop:"2em"}}>Flags</h3>
                    <ul className="objectives">  {this.state.videos? (
                          this.state.videos.map( (key,index)=>{
                          return   <>
                          
                          {key.name.includes('Flag')? <li key={index}>
                      <span
                        onClick={(event) => {
                          event.stopPropagation();
                          event.target.parentNode.parentNode.classList.toggle(
                            "expanded"
                          );
                        }}
                      >
                        <h4>
                {index+1}
                        </h4>
                      
                      </span>

                      <div className="content">
                          
                            <div className="vimeo-wrapper">  <iframe
                          src={
                            "https://player.vimeo.com/video/" +
                            key.link.split("/")[3] +
                            "?byline=0&portrait=0"
                          }
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay; fullscreen"
                          allowFullScreen=""
                        ></iframe><span className="spin"></span></div><br/>
                        
                        
                        </div></li>:''}
                        
                        
                        
                        </>
                        
                        })

                          ):""}</ul>
                        </>
  ) : this.state.location === "M2M" ? (
    <>
      <h3>Objectives</h3>
      <ul className="objectives">
      {this.state.data?.objectives?.map((key, index) => {
          return (
            <li key={key.tag}>
              <span
                onClick={(event) => {
                  event.stopPropagation();
                  event.target.parentNode.parentNode.classList.toggle(
                    "expanded"
                  );
                }}
              >
                <h4>
                  {isNumber(key.tag[0]) ? (
                    key.tag
                  ) : (
                    <>
                      {index + 1} {key.tag}
                    </>
                  )}
                </h4>
                <span className="points total">
                  {key.points +
                    (key.hints
                      ? this.addPoints(key.hints)
                      : 0)}{" "}
                  Points
                </span>
              </span>

              <div className="content">
                {this.state.videos&&this.state.videos[index] && (
                <>{this.state.videos.map( (keyV,i) => {
                  let portNumber;
                  const indexVideo = index+1
                if ( keyV.name.includes("Obj0"+(indexVideo)) ) {
                    if ((indexVideo === 1 && i === 0) || (indexVideo === 2 && i === 2)) {
                      portNumber = 'Port 80 or 8080'
                    } else if((indexVideo === 1 && i === 1) || (indexVideo === 2 && i === 3)) {
                      portNumber = 'Port 81 or 9999'
                    }

                    return   (
                      <>
                        {portNumber && <h5>{portNumber}</h5>}
                        <div className="vimeo-wrapper">
                          <iframe
                            src={`https://player.vimeo.com/video/${keyV.link.split("/")[3]}?title=0&byline=0&portrait=0`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay; fullscreen"
                            allowFullScreen=""
                          ></iframe>
                          <span className="spin"></span>
                        </div><br />
                      </>
                    )
                  }
                })}</>

              )}

  

                <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                {this.state.data.configurations.tyr ? (
                  <Tyr
                    tyr={
                      this.state.data.configurations.tyr.salt
                        .questions[0][index]
                    }
                  />
                ) : (
                  ""
                )}

                {key.hints
                  ? this.hints(key.hints)
                  : "no hints"}
              </div>
            </li>
          );
        })}
      </ul>
    </>
  ) : (
                        <>
                          <h3>Objectives</h3>{/*ALL SCENARIOS */}
                          <ul className="objectives">
                          {this.state.data?.objectives?.map((key, index) => {
                              return (
                                <li key={key.tag}>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                      {isNumber(key.tag[0]) ? (
                                        key.tag
                                      ) : (
                                        <>
                                          {index + 1} {key.tag}
                                        </>
                                      )}
                                    </h4>
                                    <span className="points total">
                                      {key.points +
                                        (key.hints
                                          ? this.addPoints(key.hints)
                                          : 0)}{" "}
                                      Points
                                    </span>
                                  </span>
  
                                  <div className="content">

                                  {this.state.videos&&this.state.videos[index]? (
                                    <div className="vimeo-wrapper">  <iframe
                                    src={
                                      "https://player.vimeo.com/video/" +
                                      this.state.videos[index].link.split("/")[3] +
                                      "?title=0&byline=0&portrait=0"
                                    }
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen=""
                                  ></iframe><span className="spin"></span></div>
                                      ):""}

                      
  
                                    <p> {key.description.replace( /(<([^>]+)>)/ig, '')}</p>
                                    {this.state.data.configurations.tyr ? (
                                      <Tyr
                                        tyr={
                                          this.state.data.configurations.tyr.salt
                                            .questions[0][index]
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}

                                    {key.hints
                                      ? this.hints(key.hints)
                                      : "no hints"}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      )   
                    )  
                      } inProgress={"authenticating"} unauthenticated={<><h3>Scenario Detail Information</h3><p>Are you a Trainer?  Use your <strong>Project Ares credentials to log in</strong> to access this scenario's hints, answers, and scoring.</p></>}/>
                    </>
                  ) : this.state.error &&
                    this.props.email.split("@")[1] == "circadence.com" ? (
                    <div id="yaml-error">
                      {this.state.error.message}
                      <br />
                      <br />
                      <strong>name:</strong> {this.state.error.name}
                      <br />
                      <br />
                      <strong>reason:</strong>
                      {this.state.error.reason}
                    </div>
                  ) : this.state.error ? (
                    "An error with the hint is currently being corrected"
                  ) : (
                   " "
                  )
                }
              />
            }
          </>
        ) : (
         this.state.location?<Spinner/>:""
        )}
      </>
    );
  }
}
export default Data;
